import React, { ChangeEvent, useEffect, useState } from "react";
import { Button, Card, CardBody, Container } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthContext";
import { IQuerySelectData, IItemBaseVariant } from "../../../component/solution/Interfaces";
import { ArrowLeft, FileText, ImageOff, Search, UploadCloud, X } from "lucide-react";
import { useLocation } from "react-router-dom";


export const ProductsVarieties: React.FC = () => {


    const { fetchData }  = useAuth();
    const location = useLocation();
    const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
    const fetchProductVariantActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_VARIANT_ACTIONS/run`; 
        
    
    const [tableRows, setTableRows] = useState<React.ReactElement[]>([]);
    const [viewMode, setViewMode] = useState<'default' | 'edit' | 'seo' | 'channels' | 'history'>('default'); 
    
    const defaultQueryState: IQuerySelectData = { appCode: "sa_stock", selectCode: "product_variant_list", where: "", orderBy: "", pageNum: 0, pageSize: 100};    
    const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

    const defaultSearchState = { name: "", sku: "",  opts: "", price: "",  created: "", updated: ""};
    const [searchState, setSearchState] = useState<{ [key: string]: string }>(defaultSearchState);

    const [selectedVariant, setSelectedVariant] = useState<IItemBaseVariant | null>(null);
    const [tableData, setTableData] = useState<IItemBaseVariant[]>([]);
    const [checkedRows, setCheckedRows] = useState<boolean[]>([]);
    const [allChecked, setAllChecked] = useState(false);


    const [channelView, setChannelView] = useState("channel one"); // default to one
    const [previewImages, setPreviewImages] = useState<string[]>([]);

    const [carouselIndexes, setCarouselIndexes] = useState<Record<string, number>>({});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [carouselStartIndex, setCarouselStartIndex] = useState(0);

    //handling the opening of the images modal
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState<string[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [carouselBaseImagesIndex, setCarouselBaseImagesIndex] = useState(0);


    const [channelStatus, setChannelStatus] = useState<Record<string, boolean>>({
      "channel one": true,
      "channel two": false,
      "channel three": false,
      "channel four": true,
      "channel five": false,
    });

      //Form Data Settings 
      const [formDataVariantProductName, setFormDataVariantProductName] = useState<{id: string, sku: string, name: string}>({ id: "", sku: "", name: "",}); 
      const [initialFormDataVariantProductName, setInitialFormDataVariantProductName] = useState<{name: string }>({ name: "", });
      const [showSaveBanner, setShowSaveBanner] = useState<boolean>(false); 

    
     //Pagination Testing 
    const [pageNumber, setPageNumber] = useState<number>(0); 
    const [pageSize, setPageSize] = useState<number>(100);   
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);

    useEffect(() => {
          setViewMode("default");
    }, [location.key]);

    useEffect(() => {
        if(viewMode === "default"){
            fetchVariantItems(); //fetch 
        }
    }, [queryState, viewMode]);

    // Pagination updates
    useEffect(() => {
        setQueryState(prev => ({
            ...prev,
            pageNum: pageNumber,
            pageSize: pageSize,
        }));
    }, [pageNumber, pageSize]);
    

    const fetchVariantItems = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryState)}, processData );
    }

    const processData = (result: any) => {
      
         console.log(`variants data`, result);

        const data: IItemBaseVariant[] = [];

        for (const key in result.data) {
            const item = result.data[key];
            data.push({ ...item.data, ...item.control, id: item.id });
        }


        setTableData(data);
        setCheckedRows(Array(data.length).fill(false));
        setAllChecked(false); // reset header checkbox

        // Pagination 
        setPageSize(pageSize);
        setTotalRecords(result?.numRecords);
        setTotalPages(Math.ceil(result?.numRecords / pageSize));
    };


    const buildTableRows = (data: IItemBaseVariant[]): React.ReactElement[] => {
        const rowElements: React.ReactElement[] = [];
        const cellStyle: React.CSSProperties = { whiteSpace: 'nowrap', padding: '4px 6px', fontSize: '0.75rem', verticalAlign: 'middle', borderRight: 'none', borderLeft: 'none', borderTop:'1px solid #deebed', borderBottom:'1px solid #deebed' };
          

        data.forEach((record, index) => {
            const { id, name, sku, price, product_base_assets, opts,  is_closed } = record;

            rowElements.push(
            <tr id={`${index}`} key={id}>
                <td style={cellStyle}>
                  <div className="table-image-container" 
                    style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40px', maxHeight: '60px', overflow: 'hidden', boxShadow: 'none' }}
                    onMouseEnter={(e) => {
                      const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                      if (icon) icon.style.opacity = '1';
                    }}
                    onMouseLeave={(e) => {
                      const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                      if (icon) icon.style.opacity = '0';
                    }}
                    >
                    {Array.isArray(product_base_assets) && product_base_assets.length > 0 ? (
                      <>
                        <img src={product_base_assets[0].url} alt={name} title={name}
                          style={{ maxHeight: '40px', maxWidth: '100%', borderRadius: '4px', objectFit: 'contain', display: 'block'}}
                          onClick={() => handleSelectedItem(record)}
                          onError={(e) => (e.currentTarget.style.display = 'none')}
                        />
    
                        {/* Search icon, shown on hover only (via opacity, not display) */}
                        <div className="hover-search-icon" 
                          style={{opacity: 0,transition: 'opacity 0.2s ease', position: 'absolute', top: '0px', right: '0px', cursor: 'pointer', zIndex: 10}}
                          onClick={(e) => { e.stopPropagation(); handleViewImages(product_base_assets); setSelectedProduct(name); }}
                        >
                          <Search size={16} color="#555" />
                        </div>
                      </>
                    ) : (
                       <div style={{width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleSelectedItem(record)} >
                          <ImageOff size={24} color="#ccc" />
                      </div>
                    )}
                  </div>
                </td>
                <td style={cellStyle} title={sku}>{sku}</td>
                <td style={{ ...cellStyle, position: 'relative' }} title={name}>
                    <div >
                        <span>{name}</span>
                        {is_closed && (
                        <span className="badge" title="This item is disabled"
                         style={{ position: 'absolute', top: '4px', right: '6px', fontSize: '0.65rem', borderRadius: '6px', padding: '2px 6px', backgroundColor: '#f72832', zIndex: 1}}
                        >
                            Disabled
                        </span>
                        )}
                    </div>
                </td>
               <td style={cellStyle} title={Object.entries(opts).map(([k, v]) => `${k}: ${v}`).join(', ')}>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {Object.entries(opts).slice(0, 3).map(([key, value]) => (
                    <div key={key} style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                      <strong>{key}:</strong> {value}
                    </div>
                  ))}
                  {Object.entries(opts).length > 3 && (
                    <span style={{ whiteSpace: 'nowrap' }}>…</span>
                  )}
                </div>
              </td>
                <td style={cellStyle} title={`${price}`}>{price}</td>
                <td style={cellStyle}>
                    {/* <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='View' onClick={() => handleSelectedItem(record)}>
                        <FileText style={{ width: "20px", height: "20px" }} />
                    </button> */}
                  
                </td>
            </tr>
            );
        });

        return rowElements;
    };


     const handleSelectedItem = ( item: IItemBaseVariant) => {
    
        //return is item is missing. 
        if (!item) return;

         // Set form data from item
        const newFormData = { id: item.id || "", sku: item.sku || "", name: item.name || ""};

        setFormDataVariantProductName(newFormData);
        setInitialFormDataVariantProductName(newFormData); 

    
        setSelectedVariant(item);
        setViewMode("edit");
      }


    const handleSearchOnChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { id, value } = event.target;
      setSearchState((prev) => ({ ...prev, [id]: value.trim() }));
    };

    const handleViewImages = (images: { url: string }[]) => {
     setSelectedImages(images.map((img) => img.url));
     setIsImageModalOpen(true);
    };

    const handleToggleAll = () => {
      const newValue = !allChecked;
      setAllChecked(newValue);
      setCheckedRows(Array(tableData.length).fill(newValue));
    };

    const handleRowToggle = (index: number) => {
      const updated = [...checkedRows];
      updated[index] = !updated[index];
      setCheckedRows(updated);
      setAllChecked(updated.every(Boolean));
    };


    function parseDate(value: string): string {
        const trimmed = value.trim();
        let date: Date | null = null;

        // Try to match known patterns
        const matchDdMmYyyy = /^\d{2}-\d{2}-\d{4}/.test(trimmed);
        const matchYyyyMmDd = /^\d{4}-\d{2}-\d{2}/.test(trimmed);

        if (matchDdMmYyyy) {
        const [day, month, year] = trimmed.split(/[- ]/);
        date = new Date(`${year}-${month}-${day}`);
        } else if (matchYyyyMmDd) {
        date = new Date(trimmed.split(' ')[0]);
        }

        return date && !isNaN(date.getTime())
        ? date.toISOString().split('T')[0] // Format as yyyy-mm-dd
        : value;
    }

     const generateWhereClause = (search: { [key: string]: string }) => {
        const clauses = Object.entries(search)
        .filter(([_, value]) => value.trim() !== "")
        .map(([key, value]) => {
            if (key === "created" || key === "updated") {
            const parsedDate = parseDate(value);
            return `${key}::date = '${parsedDate.replace(/'/g, "''")}'`;
            } else {
            return `${key} ILIKE '%${value.replace(/'/g, "''")}%'`;
            }
        });
        return clauses.join(" AND ");
    };

    const searchClicked = () => {
        // Reset pagination state
        setPageNumber(0); // Reset page to first page
        setPageSize(100); // Reset page size to 100

        const whereClause = generateWhereClause(searchState);

        setQueryState(prev => ({
        ...prev,
        where: whereClause,
        pageNum: 0, // Ensure that the query state reflects the reset page number
        pageSize: 100, // Ensure the query state reflects the reset page size
        }));
    };
    
    const clearSearchClicked = () => {
        setSearchState(defaultSearchState);
        setQueryState(defaultQueryState);
    }    
    
    

    // Pagination handlers
    const goToFirstPage = () => setPageNumber(0);
    const goToPreviousPage = () => setPageNumber(prev => prev - 1);
    const goToNextPage = () => setPageNumber(prev => prev + 1);
    const goToLastPage = () => setPageNumber(totalPages - 1);

    // Update page size handler
    const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
    };


    const getDynamicColumnsFromOpts = (optsArray: Record<string, string>[]): string[] => {
        const uniqueKeys = new Set<string>();
        for (const opts of optsArray) {
            Object.keys(opts).forEach((key) => uniqueKeys.add(key));
        }
        return Array.from(uniqueKeys);
    };


    const columnHeaders = [
        { key: 'image', label: 'Image' },
        { key: 'sku', label: 'SKU' },
        { key: 'name', label: 'Name' },
        { key: 'opts', label: 'Opts' },
        { key: 'price', label: 'Price' },
        { key: 'actions', label: 'Actions' },
    ];

    const searchFields = [
        { name: 'sku', placeholder: 'Search SKU...' },
        { name: 'name', placeholder: 'Search Name...' },
        { name: 'opts', placeholder: 'Search Opts...' },
        { name: 'price', placeholder: 'Search Price...' },
    ];


    const thStyle = {
        backgroundColor: '#293042',
         border: 'none',
         fontWeight: 600,
         color:'white',
         padding: '12px 8px', 
         fontSize: '0.75rem'
    };

    const thControlsStyle = {
        textWrap: 'nowrap',
        backgroundColor: 'white', 
        border: 'none',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding:'2px 0px',
        margin: '0px'

    };

    const thSearchStyle = {
        textWrap: 'nowrap',
        border: 'none',
        padding: '8px 4px',
        backgroundColor: 'white',
    };

    function slugifyNameForUrl(name: string): string {
      return name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')           // replace spaces with -
        .replace(/[^a-z0-9\-]/g, '')    // remove non-URL-safe characters
        .replace(/\-+/g, '-');          // collapse multiple dashes
    }


    const images = selectedVariant?.product_base_assets || [];
    const visibleImages = images.slice(carouselStartIndex, carouselStartIndex + 4);
    const canScrollLeft = carouselStartIndex > 0;
    const canScrollRight = carouselStartIndex + 4 < images.length;


    const toggleChannel = (key: string) => {
      setChannelStatus((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    };


   //handle the change of input values also based on the section thats been edited. 
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, source: string) => {
      const { name, value } = e.target;
      const trimmedValue = typeof value === "string" ? value.trimStart() : value;

      if (source === "product_variant_name") {
        const updated = { ...formDataVariantProductName, [name]: trimmedValue };
        setFormDataVariantProductName(updated);

        // Compare to original
        const isChanged = updated.name !== initialFormDataVariantProductName.name;

        setShowSaveBanner(isChanged);
      }
    };

    /* 
    retail = 
    wholesale = 
    3PL = 
    */

    // ============================
    // Handling Edit Product Data
    // ============================

    //handle the clearing of the save / discard banner
    const handleClearBanner = () => {
        setFormDataVariantProductName({ id: "", sku: "", name: "" }); 
        setInitialFormDataVariantProductName({ name: "" });
        setShowSaveBanner(false); 
    };

    //handle product variant name discard changes
    const handleProductVaraintNameDiscard = () => {
       setFormDataVariantProductName((prev) => ({
        ...prev,
        name: initialFormDataVariantProductName.name
      }));
      setShowSaveBanner(false); 
    };


     //handle product variant name 'update' save changes
    const handleProductVaraintNameSave = () => { 
        if (formDataVariantProductName.name === "") return;

        const payload = {
          ...formDataVariantProductName,
          name: formDataVariantProductName.name.trim(),
        };

       // console.log(`This is the update for the product varient`, payload);

        //perform put for the product variant name update
        fetchData(
          fetchProductVariantActionsQueryUrl,
          { method: "PUT", body: JSON.stringify(payload) },
          (result: any, status: string) => {
            if (status === "200" && selectedVariant) {
  
              //clearing the banner
              handleClearBanner();
  
              // Step 1: Re-fetch product variant 
              fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(queryState) }, (result: any) => {
                const updatedVariantItems: IItemBaseVariant[] = [];
  
                for (const key in result.data) {
                  const item = result.data[key];
                  updatedVariantItems.push({ ...item.data, ...item.control, id: item.id });
                }
  
                // // Step 2: Find the updated item and re-select it
                const updatedItem = updatedVariantItems.find(item => item.id === selectedVariant.id);
                if (updatedItem) {
                  handleSelectedItem(updatedItem); // Re-fetch variant/line-level data
                }
              });
            }
          }
        );

    };


   const cellStyle = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.2rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };

   const cellStyleImage = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.9rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };


const defaultTdStyle = {
  padding: "0.5rem",        // same as 8px
  border: "none",
  verticalAlign: "middle",     // default for <td>
  backgroundColor: "white", // or transparent depending on context
};

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                 {viewMode === "default" && 
                 <Card>
                   <Card.Header style={{padding: "15px 0px 0px 20px"}}>
                      <Card.Title>{"Product Variants"}</Card.Title>              
                   </Card.Header>
                   <CardBody>
                        {/* <div className="d-flex flex-wrap align-items-center justify-content-between mr-2 ml-2 mb-2">
                            <div className="d-flex flex-row gap-2 mt-3">
                                <h6 className="card-subtitle text-muted">Total Records: {totalRecords}</h6>
                                <h6 className="card-subtitle text-muted">Current Page : [ { pageNumber + 1 } of {totalPages} ]</h6>
                            </div>

                            <div className="d-flex align-items-center gap-3">
                              
                                <nav aria-label="">
                                    <ul className="pagination m-0">
                                        <li className="page-item">
                                            <select className="page-link" 
                                                value={pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{width: '100px', textAlign: 'center', padding: '10px'}}>
                                                <option defaultChecked value={pageSize}>{pageSize}</option>
                                                {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
                                                    <option key={size} value={size}>{size}</option>
                                                ))}
                                            </select>
                                        </li>                            
                                    </ul>
                                </nav>

                              
                                <nav aria-label="">
                                    <ul className="pagination m-0">
                                    <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>
                                        <button 
                                            className="page-link" 
                                            onClick={goToFirstPage}
                                            disabled={pageNumber === 0}
                                            style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber === 0 ? "gray" : "black"}}
                                        >
                                            |&larr;
                                        </button>
                                    </li>
                                    <li className={`page-item ${pageNumber <= 0 ? 'disabled' : ''}`}>
                                        <button 
                                            className="page-link" 
                                            onClick={goToPreviousPage}
                                            disabled={pageNumber <= 0}
                                            style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber <= 0 ? "gray" : "black"}}
                                        >
                                            &larr;
                                        </button>
                                    </li>
                                    <li className="page-item">
                                        <span className="page-link" style={{ padding: "8px 14px 8px 14px"}}>
                                            Page {pageNumber + 1} of {totalPages}
                                        </span>
                                    </li>
                                    <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''} `}>
                                        <button 
                                            className="page-link" 
                                            onClick={goToNextPage}
                                            disabled={pageNumber >= totalPages - 1}
                                            style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber >= totalPages - 1 ? "gray" : "black"}}
                                        >
                                            &rarr;
                                        </button>
                                    </li>
                                    <li className={`page-item ${pageNumber >= totalPages - 1  ? 'disabled' : ''}`}>
                                        <button 
                                            className="page-link" 
                                            onClick={goToLastPage}
                                            disabled={pageNumber >= totalPages - 1}
                                            style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber >= totalPages - 1 ? "gray" : "black"}}
                                        >
                                            &rarr;|
                                        </button>
                                    </li>
                                    </ul>
                                </nav>

                            </div>
                        </div> 

                        <div className="sa-table-container" >
                        <table className="table table-bordered sa-table">
                            <>
                            <thead className="sa-list-search">
                                <tr>
                                    <td className="sa-search-control" style={thSearchStyle}></td>
                                    {searchFields.map(({ name, placeholder }) => name === 'opts' ? (
                                        <td key={name} className="sa-search-control" style={thSearchStyle}></td>
                                     ) : (
                                        <td key={name} className="sa-search-control" style={thSearchStyle}>
                                          <input id={name} name={name} value={searchState[name] ?? ''} onChange={handleSearchOnChange} type="text" autoComplete="off" placeholder={placeholder} className="form-control" />
                                        </td>
                                    )
                                    )}
                                    <td style={thControlsStyle}  className="sa-search-control">
                                        <button onClick={searchClicked} type="button" style={{border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px", padding:"2px"}}>
                                            <circle cx="11" cy="11" r="8"></circle>
                                            <path d="m21 21-4.3-4.3"></path>
                                        </svg>
                                        </button >   
                                        <button onClick={clearSearchClicked} type="button" style={{ border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px"}}>
                                                <path d="M18 6 6 18"></path>
                                                <path d="m6 6 12 12"></path>
                                            </svg>
                                        </button> 
                                    </td>
                                </tr> 
                            </thead>
                            </>

                            <>
                            <thead className="sa-list-columns">
                                <tr>
                                    { columnHeaders.map(({ key, label }) => (
                                        <th key={key} style={thStyle}>{label}</th>
                                    ))}
                                </tr> 
                            </thead>
                            </>
                            <tbody>
                                {tableRows}
                            </tbody>
                        </table>  
                    </div> */}

                     <div>
                            <div style={{ width: '100%', border: '1px solid #deebed', padding: '4px 8px', backgroundColor: 'white',  borderTopLeftRadius: '10px',  borderTopRightRadius: '10px', }}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row gap-2" style={{marginTop: '14px'}}>
                                            <h6 className="card-subtitle text-muted">Total Records: {totalRecords} </h6> 
                                            <h6 className="card-subtitle text-muted">Current Page :  [{ pageNumber + 1 } of {totalPages}]</h6> 
                                        </div>

                                        <div className="d-flex align-items-center gap-3">
                                            {/* // Page Size */}
                                            <nav aria-label="">
                                                <ul className="pagination m-0">
                                                    <li className="page-item">
                                                        <select className="page-link" 
                                                            value={pageSize}
                                                            onChange={handlePageSizeChange}
                                                            style={{width: '100px', textAlign: 'center', padding: '10px'}}>
                                                            <option defaultChecked value={pageSize}>{pageSize}</option>
                                                            {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
                                                              <option key={size} value={size}>{size}</option>
                                                            ))}
                                                        </select>
                                                    </li>                            
                                                </ul>
                                            </nav>

                                            {/* // Pagination Control */}
                                            <nav aria-label="">
                                                <ul className="pagination m-0">
                                                <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>  
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center"
                                                      onClick={goToFirstPage}
                                                      disabled={pageNumber === 0}
                                                      style={{ fontSize: '20px', padding: '0px 8px 4px 8px', height: '38px', marginTop:'1px', color: pageNumber === 0 ? "gray" : "black" }}
                                                    >
                                                    <span style={{ lineHeight: 1, display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                      <span>|</span>
                                                      <span style={{ position: 'relative', top: '-1px' }}>&larr;</span>
                                                    </span>
                                                  </button>
                                                </li>
                                                <li className={`page-item ${pageNumber <= 0 ? 'disabled' : ''}`}>  { /*  */ }
                                                    <button 
                                                        className="page-link" 
                                                        onClick={goToPreviousPage}
                                                        disabled={pageNumber <= 0}
                                                        style={{fontSize: '20px', padding: "0px 8px 4px 8px", height: '38px', marginTop:'1px', color: pageNumber <= 0 ? "gray" : "black"}} 
                                                    >
                                                      <span style={{ position: 'relative', top: '-1px' }}>&larr;</span>
                                                    </button>
                                                </li>
                                                <li className="page-item">
                                                    <span className="page-link" style={{ padding: "8px 14px 8px 14px", height: '38px', marginTop:'1px'}}>
                                                        Page {pageNumber + 1} of {totalPages}  
                                                    </span>
                                                </li>
                                                <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''} `}>  
                                                    <button 
                                                        className="page-link" 
                                                        onClick={goToNextPage}
                                                        disabled={pageNumber >= totalPages - 1}
                                                        style={{fontSize: '20px', padding: "0px 8px 4px 8px", height: '38px', marginTop:'1px', color: pageNumber >= totalPages - 1 ? "gray" : "black"}}  
                                                    >
                                                      <span style={{ position: 'relative', top: '-1px' }}>&rarr;</span>
                                                    </button>
                                                </li>
                                                <li className={`page-item ${pageNumber >= totalPages - 1  ? 'disabled' : ''}`}> 
                                                    <button 
                                                      className="page-link d-flex align-items-center justify-content-center"
                                                      onClick={goToLastPage}
                                                      disabled={pageNumber >= totalPages - 1}
                                                      style={{ fontSize: '20px', padding: '0px 8px 4px 8px', height: '38px', marginTop:'1px', color: pageNumber >= totalPages - 1 ? "gray" : "black" }}
                                                    >
                                                    <span style={{ lineHeight: 1, display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                      <span style={{ position: 'relative', top: '-1px' }}>&rarr;</span>
                                                      <span>|</span>
                                                    </span>
                                                  </button>
                                                </li>
                                                </ul>
                                            </nav>

                                        </div>
                                </div>
                            </div>
                            <table className="table table-md table-hover-light w-100 mb-0">
                                {/* FILTER INPUTS HEADER */}
                                <thead>
                                  <tr>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px', borderLeft: '1px solid #deebed' }}></th> 
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                     { searchFields.map(({ name, placeholder }) => (
                                         <td key={name} style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                          <input id={name} name={name} value={searchState[name] ?? ''} onChange={handleSearchOnChange} type="text" autoComplete="off"  placeholder={placeholder} className="form-control form-control-md" />
                                        </td>
                                    ))}
                                    <th style={{ backgroundColor: 'white', padding: '4px 8px', borderRight: '1px solid #deebed' }}>
                                        <div className="d-flex gap-1 w-100">
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-md w-100"
                                            onClick={searchClicked}
                                          >
                                            <Search  style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-md w-100"
                                            onClick={clearSearchClicked}
                                          >
                                            <X style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                        </div>
                                      </th>
                                  </tr>
                                </thead>
                                <thead>
                                    <tr>
                                        <td style={{ fontWeight: "600",  backgroundColor: 'white', borderLeft: '1px solid #deebed'}}>
                                             <input
                                                type="checkbox"
                                                className="custom-red-checkbox"
                                                checked={allChecked}
                                                onChange={handleToggleAll}
                                                 style={{ height: '14px', width: '14px' }}
                                              />
                                        </td>
                                        {columnHeaders.map(({ key, label }, index) => (
                                        <th
                                          key={key}
                                          style={{
                                            fontWeight: "600",
                                            backgroundColor: "white",
                                            paddingLeft: "20px",
                                            ...(index === columnHeaders.length - 1 && { borderRight: '1px solid #deebed' }),
                                          }}
                                        >
                                          {label}
                                        </th>
                                      ))}
                                    </tr>
                                </thead>
                                <tbody>
                        
                                   {tableData.map((record, index) => {

                                    const { id, name, sku, price, product_base_assets, opts,  is_closed } = record;
                                    const cellStyle: React.CSSProperties = { whiteSpace: 'nowrap', padding: '4px 6px', fontSize: '0.75rem', verticalAlign: 'middle', borderRight: 'none', borderLeft: 'none', borderTop:'1px solid #deebed', borderBottom:'1px solid #deebed' };
  
                                    return (
                                          <tr id={`${index}`} key={id}>
                                              <td style={{...cellStyle, paddingLeft: '12px'}}>
                                                   <input
                                                    type="checkbox"
                                                    className="custom-red-checkbox"
                                                    checked={checkedRows[index] || false}
                                                    onChange={() => handleRowToggle(index)}
                                                    style={{ height: '14px', width: '14px' }}
                                                  />
                                            </td>
                                            <td style={cellStyle}>
                                              <div className="table-image-container" 
                                                style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40px', maxHeight: '60px', overflow: 'hidden', boxShadow: 'none' }}
                                                onMouseEnter={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '1';
                                                }}
                                                onMouseLeave={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '0';
                                                }}
                                                >
                                                {Array.isArray(product_base_assets) && product_base_assets.length > 0 ? (
                                                  <>
                                                    <img src={product_base_assets[0].url} alt={name} title={name}
                                                      style={{ maxHeight: '40px', maxWidth: '100%', borderRadius: '4px', objectFit: 'contain', display: 'block'}}
                                                      onClick={() => handleSelectedItem(record)}
                                                      onError={(e) => (e.currentTarget.style.display = 'none')}
                                                    />
                                
                                                    {/* Search icon, shown on hover only (via opacity, not display) */}
                                                    <div className="hover-search-icon" 
                                                      style={{opacity: 0,transition: 'opacity 0.2s ease', position: 'absolute', top: '0px', right: '0px', cursor: 'pointer', zIndex: 10}}
                                                      onClick={(e) => { e.stopPropagation(); handleViewImages(product_base_assets); setSelectedProduct(name); }}
                                                    >
                                                      <Search size={16} color="#555" />
                                                    </div>
                                                  </>
                                                ) : (
                                                  <div style={{width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleSelectedItem(record)} >
                                                      <ImageOff size={24} color="#ccc" />
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}} title={sku}>{sku}</td>
                                            <td style={{ ...cellStyle, position: 'relative', paddingLeft: '20px' }} title={name}>
                                                <div >
                                                    <span>{name}</span>
                                                    {is_closed && (
                                                    <span className="badge" title="This item is disabled"
                                                    style={{ position: 'absolute', top: '4px', right: '6px', fontSize: '0.65rem', borderRadius: '6px', padding: '2px 6px', backgroundColor: '#f72832', zIndex: 1}}
                                                    >
                                                        Disabled
                                                    </span>
                                                    )}
                                                </div>
                                            </td>
                                          <td style={{...cellStyle, paddingLeft: '20px'}} title={Object.entries(opts).map(([k, v]) => `${k}: ${v}`).join(', ')}>
                                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                              {Object.entries(opts).slice(0, 3).map(([key, value]) => (
                                                <div key={key} style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                  <strong>{key}:</strong> {value}
                                                </div>
                                              ))}
                                              {Object.entries(opts).length > 3 && (
                                                <span style={{ whiteSpace: 'nowrap' }}>…</span>
                                              )}
                                            </div>
                                          </td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}} title={`${price}`}>{price}</td>
                                            <td style={{...cellStyle, paddingLeft: '20px'}}>

                                              
                                            </td>
                                        </tr>
                                    );
                                  })}
                                    
                                </tbody>
                              </table>
                            </div>
                   </CardBody>
                 </Card>
                }

                 { viewMode !== "default" && 
                 <Card>
                     <Card.Header style={{ padding: "15px 20px 0px 20px", position: "relative",  display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                     {/* Left: Title */}
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Card.Title style={{ margin: 0 }}>Product Variant View</Card.Title>
                     </div>

                      {/* Center: Inline Save Banner */}
                      {showSaveBanner && (
                        <div className="save-banner">
                          <span className="save-message">You have unsaved changes</span>
                          <Button className="btn-save" size="sm" onClick={handleProductVaraintNameSave}> 
                            Save
                          </Button>
                          <Button className="btn-discard" size="sm" variant="outline" onClick={handleProductVaraintNameDiscard}>
                            Discard
                          </Button>
                        </div>
                      )}

                     {/* Right: Back Button */}
                      <button className="custom-back-btn" title="Back To Product Variants" onClick={() => {
                          setViewMode("default");
                          handleClearBanner();
                        }}>
                      <ArrowLeft size={18} />
                    </button>
                  </Card.Header>
                  
                   <Card.Body style={{ backgroundColor:"#f5f7fa" , borderRadius: "0 0 0.5rem 0.5rem", margin:'10px 4px 4px 4px', border:'1px solid #e1e5ec'}}>
                    <div className="d-flex border-bottom mb-4" style={{ gap: '1rem' }}>
                     {[
                        { key: 'edit', label: 'Edit Product Variant' },
                        { key: 'seo', label: 'SEO Settings', disabled: true },
                        { key: 'channels', label: 'Channels' , disabled: true },
                        { key: 'history', label: 'History', disabled: true },
                      ].map(({ key, label, disabled }) => (
                      <button
                          key={key}
                          className={`border-0 bg-transparent fw-semibold px-3 pb-2 position-relative ${
                            viewMode === key ? 'text-primary' : 'text-muted'
                          } ${disabled ? 'text-muted opacity-50 cursor-default' : 'cursor-pointer'}`}
                          style={{
                            fontSize: '0.85rem',
                            borderBottom: viewMode === key ? '3px solid #0d6efd' : '3px solid transparent',
                            transition: 'all 0.3s ease',
                            pointerEvents: disabled ? 'none' : 'auto',
                          }}
                          disabled={disabled}
                          onClick={() => {
                            if (!disabled) setViewMode(key as typeof viewMode);
                          }}
                        >
                          {label}
                        </button>
                    ))}
                  </div>

                    { viewMode === "edit" && selectedVariant && (
                      <> 
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-2">
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder" style={{ paddingLeft: "4px" }}>
                          Product Information:
                        </h6>
                      </div>

                      <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                        <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name </label>
                        <input type="text" className="form-control" name="name" value={formDataVariantProductName.name} onChange={(e) => handleOnChange(e, "product_variant_name")} />
                      </div>


                      <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                         Product Image Information:
                      </h6>

                  
                     <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec" }}>
                      <label className="form-label fw-semibold" style={{ paddingLeft: "1.9rem" }}>Product Variant Images</label>

                       <div className="d-flex align-items-center gap-2">
                        {/* Left arrow */}
                        <button
                          type="button"
                          disabled={!canScrollLeft}
                          onClick={() => setCarouselStartIndex((prev) => Math.max(prev - 1, 0))}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: "1.5rem",
                            cursor: canScrollLeft ? "pointer" : "not-allowed",
                            opacity: canScrollLeft ? 1 : 0.3,
                          }}
                        >
                          ‹
                        </button>

                        {/* Image thumbnails OR "No image" fallback */}
                        <div className="d-flex flex-wrap gap-3" style={{ minHeight: "100px", alignItems: "center" }}>
                          {images.length > 0 ? (
                            visibleImages.map((picture, index) => {
                              const absoluteIndex = carouselStartIndex + index;
                              const isSelected = selectedIndex === absoluteIndex;

                              return (
                                <div
                                  key={picture.id}
                                  onClick={() => setSelectedIndex(absoluteIndex)}
                                  onMouseEnter={(e) => {
                                    const controls = e.currentTarget.querySelectorAll(".hover-control") as NodeListOf<HTMLElement>;
                                    controls.forEach((ctrl) => (ctrl.style.opacity = "1"));
                                  }}
                                  onMouseLeave={(e) => {
                                    const controls = e.currentTarget.querySelectorAll(".hover-control") as NodeListOf<HTMLElement>;
                                    controls.forEach((ctrl) => (ctrl.style.opacity = "0"));
                                  }}
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    border: isSelected ? "2px solid #c84337" : "1px solid #ccc",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    background: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "relative",
                                    cursor: "pointer",
                                    transition: "transform 0.3s ease",
                                  }}
                                >
                                  <img
                                    src={picture.url}
                                    alt="Current Product"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      transition: "transform 0.3s ease",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                  />

                                  {/* Checkbox indicator */}
                                  <div
                                    className="hover-control"
                                    style={{
                                      opacity: 0,
                                      transition: "opacity 0.2s ease",
                                      position: "absolute",
                                      top: "5px",
                                      right: "5px",
                                      width: "16px",
                                      height: "16px",
                                      backgroundColor: isSelected ? "white" : "white",
                                      border:  isSelected ? "1px solid #c84337" : "1px solid #ccc",
                                      borderRadius: "3px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "12px",
                                      color: "#c84337",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {isSelected ? "✓" : ""}
                                  </div>

                                  {/* Delete icon */}
                                  <button
                                    type="button"
                                    className="hover-control"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      console.log("Delete image with ID:", picture.id);
                                    }}
                                    style={{
                                      opacity: 0,
                                      transition: "opacity 0.2s ease",
                                      position: "absolute",
                                      top: "4px",
                                      left: "4px",
                                      background: "#bebfc2",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer",
                                      color: "white",
                                      fontWeight: "bold",
                                      lineHeight: 1,
                                      padding: 0,
                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ccc",
                                fontSize: "12px",
                                textAlign: "center",
                                padding: "4px",
                                border: "1px dashed #ccc",
                                borderRadius: "10px",
                              }}
                            >
                              No image
                            </div>
                          )}
                        </div>

                        {/* Right arrow */}
                        <button
                          type="button"
                          disabled={!canScrollRight}
                          onClick={() => setCarouselStartIndex((prev) => Math.min(prev + 1, images.length - 4))}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: "1.5rem",
                            cursor: canScrollRight ? "pointer" : "not-allowed",
                            opacity: canScrollRight ? 1 : 0.3,
                          }}
                        >
                          ›
                        </button>
                      </div>


                      <small className="text-muted d-block mt-1" style={{marginLeft: "28px"}}>
                        The selected image will be the product's base photo. <br/> Remove selected images from base product.
                      </small>



                      <div className="mt-2 d-flex align-items-start gap-3" style={{marginLeft: "28px"}}>
                        <label
                          htmlFor="upload-image"
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px dashed #aaa",
                            borderRadius: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#fdfdfd",
                            cursor: "pointer",
                            transition: "background 0.2s ease",
                          }}
                        >
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <UploadCloud size={24} color="#666" />
                            <small className="text-muted">Select New</small>
                        </div>
                          <input
                            id="upload-image"
                            type="file"
                            accept="image/*"
                            multiple
                            style={{ display: "none" }}
                            onChange={(e) => {
                            const files = Array.from(e.target.files || []);
                            files.forEach((file) => {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setPreviewImages((prev) => [...prev, reader.result as string]);
                              };
                              reader.readAsDataURL(file);
                            });
                          }}
                          />
                        </label>

                        {previewImages.map((image, idx) => (
                        <div
                          key={idx}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "2px dotted #aaa",
                            borderRadius: "10px",
                            overflow: "hidden",
                            background: "#f8fff8",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <img
                            src={image}
                            alt={`Preview ${idx + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            type="button"
                            onClick={() =>
                              setPreviewImages((prev) =>
                                prev.filter((_, i) => i !== idx)
                              )
                            }
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "4px",
                              background: "rgba(255, 255, 255, 0.8)",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              fontWeight: "bold",
                              color: "#333",
                              padding: 0,
                              lineHeight: 1,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                      </div>



                        <small className="text-muted d-block mt-1" style={{marginLeft: "28px"}}>
                          You can upload a new image to be added to products images.
                        </small>
                       </div>

                       <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                         Product Varaint Information:
                       </h6>

                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec"}}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                           <label className="form-label fw-semibold mb-0" style={{ paddingLeft: "1.7rem" }}>Product Variants</label>
                        </div>
                        <div className="table-responsive">
                             <table className="mb-0" style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.775rem"}}>
                               <thead>
                                <tr style={{ color: "#6c757d" }}>
                                  <th style={{ width: "70px", ...cellStyleImage }}>Image</th>
                                  <th style={cellStyle}>Name</th>
                                  <th style={cellStyle}>SKU</th>
                                   {Object.keys(selectedVariant.opts).map((column_name) => (
                                        <th key={column_name} style={cellStyle}>
                                            {column_name.charAt(0).toUpperCase() + column_name.slice(1)}
                                        </th>
                                    ))}
                                  <th style={{ width: "150px", ...cellStyle }}>Price</th>
                                  <th style={{ width: "50px", ...cellStyle }}></th>
                                </tr>
                            </thead>
                             <tbody>
                                    { selectedVariant && 
                                        <React.Fragment >
                                        <tr>
                      
                                        <td style={{ paddingTop: "0.75rem", ...defaultTdStyle}}>
                                          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            {/* Left Arrow */}
                                            <button
                                              onClick={() =>
                                                setCarouselIndexes((prev) => ({
                                                  ...prev,
                                                  [selectedVariant.id]: Math.max((prev[selectedVariant.id] || 0) - 1, 0),
                                                }))
                                              }
                                              disabled={
                                                !selectedVariant.product_base_assets ||
                                                (carouselIndexes[selectedVariant.id] || 0) === 0
                                              }
                                              style={{
                                                background: "none",
                                                border: "none",
                                                fontSize: "16px",
                                                cursor:
                                                  !selectedVariant.product_base_assets ||
                                                  (carouselIndexes[selectedVariant.id] || 0) === 0
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity:
                                                  !selectedVariant.product_base_assets ||
                                                  (carouselIndexes[selectedVariant.id] || 0) === 0
                                                    ? 0.3
                                                    : 1,
                                                padding: "0 4px",
                                              }}
                                            >
                                              ‹
                                            </button>

                                            {/* Image Container */}
                                            <div
                                              style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                border: "1px solid #ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#f9f9f9",
                                              }}
                                            >
                                              {selectedVariant.product_base_assets?.length ? (
                                                <img
                                                  src={
                                                    selectedVariant.product_base_assets[
                                                      carouselIndexes[selectedVariant.id] || 0
                                                    ]?.url
                                                  }
                                                  alt="Variant"
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.3s ease",
                                                  }}
                                                  onMouseEnter={(e) =>
                                                    (e.currentTarget.style.transform = "scale(1.2)")
                                                  }
                                                  onMouseLeave={(e) =>
                                                    (e.currentTarget.style.transform = "scale(1)")
                                                  }
                                                />
                                              ) : (
                                                <span style={{ fontSize: "10px", color: "#aaa" }}>No Image</span>
                                              )}
                                            </div>

                                            {/* Right Arrow */}
                                            <button
                                              onClick={() =>
                                                setCarouselIndexes((prev) => ({
                                                  ...prev,
                                                  [selectedVariant.id]: Math.min(
                                                    (prev[selectedVariant.id] || 0) + 1,
                                                    (selectedVariant.product_base_assets?.length || 0) - 1
                                                  ),
                                                }))
                                              }
                                              disabled={
                                                !selectedVariant.product_base_assets ||
                                                (carouselIndexes[selectedVariant.id] || 0) >=
                                                  selectedVariant.product_base_assets.length - 1
                                              }
                                              style={{
                                                background: "none",
                                                border: "none",
                                                fontSize: "16px",
                                                cursor:
                                                  !selectedVariant.product_base_assets ||
                                                  (carouselIndexes[selectedVariant.id] || 0) >=
                                                    selectedVariant.product_base_assets.length - 1
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity:
                                                  !selectedVariant.product_base_assets ||
                                                  (carouselIndexes[selectedVariant.id] || 0) >=
                                                    selectedVariant.product_base_assets.length - 1
                                                    ? 0.3
                                                    : 1,
                                                padding: "0 4px",
                                              }}
                                            >
                                              ›
                                            </button>
                                          </div>
                                        </td>
                                            <td style={{ paddingTop: "0.75rem", position: "relative", ...defaultTdStyle}}>
                                            {selectedVariant.is_closed && (
                                                <span
                                                className="badge"
                                                title="This item is disabled"
                                                style={{ position: "absolute", top: "8px", right: "12px", fontSize: "0.65rem", borderRadius: "6px", padding: "4px 4px 2px 4px", zIndex: 2, backgroundColor: '#f72832'}}
                                                >
                                                Disabled
                                                </span>
                                            )}
                                            <input type="text" className="form-control" placeholder="Variant name" title={selectedVariant.name} value={selectedVariant.name} disabled />
                                            </td>

                                            <td style={{ paddingTop: "0.75rem", ...defaultTdStyle}}>
                                            <input type="text" className="form-control" placeholder="SKU" title={selectedVariant.sku} value={selectedVariant.sku} disabled />
                                            </td>
                                            {Object.keys(selectedVariant.opts).map((column_name) => (
                                            <td key={column_name} style={{ paddingTop: "0.75rem", ...defaultTdStyle}}>
                                                <input
                                                type="text"
                                                className="form-control"
                                                value={selectedVariant.opts[column_name] || ""}
                                                disabled
                                                title={selectedVariant.opts[column_name] || ""}
                                                />
                                            </td>
                                            ))}
                                            <td style={{ paddingTop: "0.75rem", position: "relative", ...defaultTdStyle}}>
                                              <input type="text" inputMode="decimal" className="form-control" title={`${selectedVariant.price}`} placeholder="0.00" value={selectedVariant.price}  disabled />
                                            </td>
                                        </tr>
                                        </React.Fragment>
                                    }
                            </tbody>
                        </table>
                        </div>
                     </div>
                      </>
                    )}

                    
                    { viewMode === "seo" && selectedVariant && (
                       <>

                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          Product Information:
                        </h6>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name</label>
                          <input type="text" className="form-control" value={selectedVariant.name} id="productTitle" placeholder="Enter product name" disabled />
                        </div>
                       
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          SEO Information:
                        </h6>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Title</label>
                          <input type="text" className="form-control"  placeholder="Enter product meta tag title" disabled />
                        </div>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Description</label>
                          <textarea className="form-control" rows={6} placeholder="Write a detailed meta tag description..."  disabled/>
                        </div>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Keywords</label>
                          <textarea className="form-control"  rows={6} placeholder="Write a detailed meta tag keywords..."  disabled/>
                        </div>

                      
                        <p className="text-muted" style={{ paddingLeft: "1.6rem" }}><b>Suggest Url Slug:</b> {`${slugifyNameForUrl(selectedVariant.name)}`}</p>
                        
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Url Slug</label>
                          <input type="text" className="form-control"  placeholder="Enter url slug" disabled />
                          <p style={{ paddingLeft: "0.75rem" }} className="text-muted d-block mt-2">A URL slug is the last part of the URL address that serves as a unique identifier of the page.</p>
                        </div>
                      </>
                    )} 

                     { viewMode === "channels" && selectedVariant && (
                      <>
                       <div className="mb-4">
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                          Channel Status Overview:
                        </h6>

                        <div className="table-responsive bg-white p-1 rounded shadow-sm border mt-2">
                          <table className="table table-sm align-middle mb-0">
                            <thead className="bg-light text-muted">
                              <tr>
                                <th style={{ width: "30%", background: "rgb(41, 48, 66)", color: "white" }}>Channel</th>
                                <th style={{ width: "20%", background: "rgb(41, 48, 66)", color: "white" }}>Status</th>
                                <th style={{ width: "20%", background: "rgb(41, 48, 66)", color: "white" }}>Toggle</th>
                              </tr>
                            </thead>
                             <tbody>
                                {[
                                  { key: "channel one", label: "Amazon", hasAccess: true },
                                  { key: "channel two", label: "Google Merchant Center", hasAccess: false },
                                  { key: "channel three", label: "Shopify", hasAccess: true },
                                  { key: "channel four", label: "Takealot", hasAccess: true },
                                  { key: "channel five", label: "WooCommerce", hasAccess: false },
                                ]
                                  .sort((a, b) => Number(b.hasAccess) - Number(a.hasAccess))
                                  .map(({ key, label, hasAccess }) => {
                                    const isEnabled = channelStatus[key];

                                    return (
                                      <tr key={key} className={!hasAccess ? "bg-light text-muted" : ""}>
                                        <td>{label}</td>
                                        <td>
                                           <span className={`badge ${isEnabled && hasAccess ? "bg-success" : "bg-secondary"}`}>
                                            {hasAccess ? (isEnabled ? "ENABLED" : "DISABLED") : "DISABLED"}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={key}
                                              checked={isEnabled}
                                              disabled={!hasAccess}
                                              onChange={() => toggleChannel(key)}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                          </table>
                        </div>
                      </div>
                      <div>
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                             Channel Settings:
                        </h6>
                        <div className="d-flex flex-column flex-md-row gap-4 mt-2">
                            <div className="d-flex flex-md-column border-bottom border-top border-md-0 border-end pe-md-4 gap-2 gap-md-0"
                                style={{ minWidth: "180px", flexShrink: 0 }}
                              >
                               {[
                                { key: "channel one", label: "Amazon", hasAccess: true },
                                { key: "channel two", label: "Google Merchant Center", hasAccess: false },
                                { key: "channel three", label: "Shopify", hasAccess: true },
                                { key: "channel four", label: "Takealot", hasAccess: true },
                                { key: "channel five", label: "WooCommerce", hasAccess: false },
                              ]
                                .filter(({ hasAccess }) => hasAccess)
                                .map(({ key, label }) => {
                                  const isActive = channelView === key;
                                  return (
                                    <button
                                      key={key}
                                      className={`border-0 bg-transparent fw-semibold px-3 py-2 text-start position-relative w-100 ${
                                        isActive ? "text-primary" : "text-muted"
                                      }`}
                                      style={{
                                        fontSize: "0.85rem",
                                        borderLeft: isActive ? "3px solid #0d6efd" : "3px solid transparent",
                                        backgroundColor: isActive ? "#f8f9fa" : "transparent",
                                        transition: "all 0.3s ease",
                                      }}
                                      onClick={() => setChannelView(key)}
                                    >
                                      {label}
                                    </button>
                                  );
                                })}
                              </div>

                      
                          <div className="flex-grow-1">
                            {channelView === "channel one" && <p>Amazon content goes here...</p>}
                            {channelView === "channel two" && <div>
                                  <p>Google Merchant Center content goes here...</p>
                             </div>
                            }
                            {channelView === "channel three" && <p>Shopfiy content goes here...</p>}
                            {channelView === "channel four" && <p>Takealot content goes here...</p>}
                            {channelView === "channel five" && <p>WooCommerce content goes here...</p>}
                          </div>
                        </div>
                        </div>
                      </>
                    )} 

                   { viewMode === "history" && selectedVariant && (
                      <>
                         <p className="text-muted mb-4" style={{paddingLeft: "4px"}}>You are in product history mode...</p>
                      </>
                    )} 
                  </Card.Body>
                </Card>
                } 


              {isImageModalOpen && (
              <div className="modal d-block" tabIndex={-1} onClick={() => setIsImageModalOpen(false)} style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content position-relative">
                    <div className="modal-header">
                      <h5 className="modal-title text-uppercase text-secondary fw-bolder ">
                            Product : {selectedProduct}
                      </h5>
                      <button type="button" className="btn-close"
                        onClick={() => {
                          setSelectedImages([]);
                          setIsImageModalOpen(false);
                          setCarouselBaseImagesIndex(0);
                          setSelectedProduct("");
                        }}
                      />
                    </div>
                    <div style={{ position: 'absolute', top: '12px', right: '50px', fontSize: '13px', background: '#f1f1f1', padding: '4px 10px', borderRadius: '20px', color: '#555' }}>
                      {selectedImages.length} image{selectedImages.length !== 1 ? 's' : ''}
                    </div>

                    <div className="modal-body d-flex flex-column align-items-center">
                      <div className="d-flex justify-content-center align-items-center" style={{ gap: '20px' }}>
                        {/* Left Arrow */}
                        {selectedImages.length > 1 && (
                          <button
                            onClick={() => setCarouselBaseImagesIndex((prev) => Math.max(prev - 1, 0))}
                            disabled={carouselBaseImagesIndex === 0}
                            style={{ background: 'none', border: 'none',fontSize: '36px', cursor: carouselBaseImagesIndex === 0 ? 'not-allowed' : 'pointer', opacity: carouselBaseImagesIndex === 0 ? 0.3 : 1, padding: '0 10px', lineHeight: 1 }}
                          >
                            ‹
                          </button>
                        )}

                        {/* Image Preview */}
                        <div style={{ display: 'flex', gap: '10px' }}>
                          {selectedImages
                            .slice(carouselBaseImagesIndex, carouselBaseImagesIndex + 2)
                            .map((url, idx) => (
                              <div
                                key={carouselBaseImagesIndex + idx}
                                style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid #ccc', height: '380px', width: '300px', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                               >
                                <img
                                  src={url}
                                  alt={`img-${carouselBaseImagesIndex + idx}`}
                                  style={{ height: '100%', width: '100%', objectFit: 'contain', transition: 'transform 0.3s ease' }}
                                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.10)')}
                                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                />
                              </div>
                            ))}
                        </div>

                        {/* Right Arrow */}
                        {selectedImages.length > 1 && (
                          <button
                            onClick={() => setCarouselBaseImagesIndex((prev) => Math.min(prev + 1, selectedImages.length - 2))}
                            disabled={carouselBaseImagesIndex >= selectedImages.length - 2}
                            style={{ background: 'none', border: 'none', fontSize: '36px', cursor: carouselBaseImagesIndex >= selectedImages.length - 2 ? 'not-allowed' : 'pointer', opacity: carouselBaseImagesIndex >= selectedImages.length - 2 ? 0.3 : 1, padding: '0 10px', lineHeight: 1 }}
                          >
                            ›
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             )}

            </Container>
        </React.Fragment>
    );
}



//  <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">BASIC PRODUCT DATA</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//   <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>ID</td>
//         <td><input type="text" className="form-control" placeholder="Enter ID" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Name</td>
//         <td><input type="text" className="form-control" placeholder="Enter Name" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Description</td>
//         <td><textarea className="form-control" placeholder="Enter Description" disabled  rows={3}></textarea></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Link URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Link URL" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Image URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Image URL" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Additional Image URL</td>
//         <td><input type="url" className="form-control" placeholder="Enter Additional Image URL" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Mobile Link</td>
//         <td><input type="url" className="form-control" placeholder="Enter Mobile Link" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>

//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRICE & AVAILABILITY</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Availability</td>
//         <td><input type="text" className="form-control" placeholder="Enter Availability" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Availability Date</td>
//         <td><input type="text" className="form-control" placeholder="Enter Availability Date" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Cost Of Goods Sold</td>
//         <td><input type="url" className="form-control" placeholder="Enter Cost Of Goods Sold" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Expiration Date</td>
//         <td><input type="url" className="form-control" placeholder="Enter Expiration Date" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Price </td>
//         <td><input type="url" className="form-control" placeholder="Enter Price" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Sale Price</td>
//         <td><input type="url" className="form-control" placeholder="Enter Sale Price" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Sale Price Effective Date</td> 
//         <td><input type="url" className="form-control" placeholder="Enter Sale Price Effective Date" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Unit Pricing Measure</td>
//         <td><input type="url" className="form-control" placeholder="Enter Unit Pricing Measure" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Installment</td> 
//         <td><input type="url" className="form-control" placeholder="Enter Installment" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Subscription Cost </td> 
//         <td><input type="url" className="form-control" placeholder="Enter Subscription Cost" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Loyalty Program </td>
//         <td><input type="url" className="form-control" placeholder="Enter Loyalty Program" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Price</td>
//         <td><input type="url" className="form-control" placeholder="Enter Minimum Price" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRODUCT CATEGORY</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Google Product Category </td>
//         <td><input type="text" className="form-control" placeholder="Enter Google Product Category" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Product Type</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Type" disabled  /></td>
//       </tr>
//     </tbody>
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">PRODUCT IDENTIFIERS</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Brand </td>
//         <td><input type="text" className="form-control" placeholder="Enter Brand" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Global Trade Item Number</td>
//         <td><input type="text" className="form-control" placeholder="Enter Global Trade Item Number (GTIN)" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Manufacturer Part Number</td>
//         <td><input type="text" className="form-control" placeholder="Enter Manufacturer Part Number (MPN)" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Identifier Exists</td>
//         <td><input type="text" className="form-control" placeholder="Enter Identifier Exists" disabled  /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">DETAILED PRODUCT DESCRIPTION</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Condition </td>
//         <td><input type="text" className="form-control" placeholder="Enter Condition" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Adult</td>
//         <td><input type="text" className="form-control" placeholder="Enter Adult" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Multipack</td>
//         <td><input type="text" className="form-control" placeholder="Enter Multipack" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Bundle</td>
//         <td><input type="text" className="form-control" placeholder="Enter Bundle" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Certification</td>
//         <td><input type="text" className="form-control" placeholder="Enter Certification" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Energy Efficiency Class </td>
//         <td><input type="text" className="form-control" placeholder="Enter Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Energy Efficiency Class </td>
//         <td><input type="text" className="form-control" placeholder="Enter Minimum Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Maximum Energy Efficiency Class</td>
//         <td><input type="text" className="form-control" placeholder="Enter Maximum Energy Efficiency Class" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Age Group</td>
//         <td><input type="text" className="form-control" placeholder="Enter Age Group" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Color</td>
//         <td><input type="text" className="form-control" placeholder="Enter Color" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Gender</td>
//         <td><input type="text" className="form-control" placeholder="Enter Gender" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Material</td>
//         <td><input type="text" className="form-control" placeholder="Enter Material" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Pattern</td>
//         <td><input type="text" className="form-control" placeholder="Enter Pattern" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size Type</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size Type" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Size System</td>
//         <td><input type="text" className="form-control" placeholder="Enter Size System" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Item Group ID</td>
//         <td><input type="text" className="form-control" placeholder="Enter Item Group ID" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Length</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Length" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Width</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Width" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Height</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Height" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Weight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Weight" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Detail</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Detail" disabled  /></td>
//       </tr>
//         <tr>
//         <td className="fw-semibold text-muted">Product Highlight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Product Highlight" disabled  /></td>
//       </tr>
//     </tbody> 
//     </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">DESTINATIONS</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Excluded Destination</td>
//         <td><input type="text" className="form-control" placeholder="Enter Excluded Destination" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Included Destination</td>
//         <td><input type="text" className="form-control" placeholder="Enter Included Destination" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Excluded Countries For Shopping Ads</td>
//         <td><input type="text" className="form-control" placeholder="Enter Excluded Countries For Shopping Ads" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Pause</td>
//         <td><input type="text" className="form-control" placeholder="Enter Pause" disabled /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>


//   <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">SHIPPING</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Shipping</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Label</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Label" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Weight</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Weight" disabled  /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Length</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Length" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Width</td>
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Width" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Height</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Height" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Ships From Country</td>
//         <td><input type="text" className="form-control" placeholder="Enter Ships From Country" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Maximum Handling Time </td> 
//         <td><input type="text" className="form-control" placeholder="Enter Maximum Handling Time " disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Shipping Label </td> 
//         <td><input type="text" className="form-control" placeholder="Enter Shipping Label " disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Minimum Handling Time</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Minimum Handling Time" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Free Shipping Threshold</td> 
//         <td><input type="text" className="form-control" placeholder="Enter Free Shipping Threshold" disabled /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>

  
//     <div className="mb-4" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
//     <div className="d-flex justify-content-between align-items-center mb-2">
//       <p className="mb-0 fw-semibold text-muted">TAX</p>
//         <button type="button" className="btn btn-sm btn-dark d-flex align-items-center gap-1" style={{borderRadius: "0.5rem"}}>
//         <Save size={16} />
//           Save
//       </button>
//     </div>
//     <hr />
//   <table className="table table-borderless align-middle w-100" >
//     <tbody>
//       <tr>
//         <td className="fw-semibold text-muted" style={{ width: "300px" }}>Tax</td>
//         <td><input type="text" className="form-control" placeholder="Enter Tax" disabled /></td>
//       </tr>
//       <tr>
//         <td className="fw-semibold text-muted">Tax Category</td>
//         <td><input type="text" className="form-control" placeholder="Enter Tax Category" disabled  /></td>
//       </tr>
//     </tbody> 
//   </table>
//   </div>